export const MENU_ITEM_ACCOUNT_DETAILS = 'Account Details'
export const MENU_ITEM_BIDS = 'Bids'
export const MENU_ITEM_FAVORITES = 'Favorites'
export const MENU_ITEM_NOTIFICATIONS = 'Notifications'
export const MENU_ITEM_INVOICES = 'Invoices'
export const MENU_ITEM_INVOICE_ITEM = 'Invoice Item'
export const MENU_ITEM_CONSIGNMENTS = 'Consignments'

export const URL_HASH_ACCOUNT_DETAILS = '#account-details'
export const URL_HASH_BIDS = '#bids'
export const URL_HASH_FAVORITES = '#favorites'
export const URL_HASH_NOTIFICATIONS = '#alerts'
export const URL_HASH_INVOICES = '#invoices'
export const URL_HASH_INVOICE_ITEM = '#invoice-item'
export const URL_HASH_CONSIGNMENTS = '#consignments'

export const MENU_ITEMS = [
	{
		name: MENU_ITEM_ACCOUNT_DETAILS,
		hash: URL_HASH_ACCOUNT_DETAILS
	},
	{
		name: MENU_ITEM_BIDS,
		hash: URL_HASH_BIDS
	},
	{
		name: MENU_ITEM_FAVORITES,
		hash: URL_HASH_FAVORITES
	},
	{
		name: MENU_ITEM_NOTIFICATIONS,
		hash: URL_HASH_NOTIFICATIONS
	},
	{
		name: MENU_ITEM_INVOICES,
		hash: URL_HASH_INVOICES
	},
	{
		name: MENU_ITEM_INVOICE_ITEM,
		hash: URL_HASH_INVOICE_ITEM
	},
	{
		name: MENU_ITEM_CONSIGNMENTS,
		hash: URL_HASH_CONSIGNMENTS
	}
]
